// ── Lescoach: executing_coach_id is leidend, coach_id is vangnet ─────────────
// `group_lessons.coach_id` is de AANMAKER van de les, `executing_coach_id` de
// coach die de les daadwerkelijk geeft. Overal waar een coachnaam getoond
// wordt geldt de uitvoerder als leidend, met de aanmaker als fallback voor
// historische rijen waar `executing_coach_id` nog NULL is (COALESCE-gedrag).
// Verwacht een lesobject met de PostgREST-embeds `executing_coach` en/of
// `coach`.
//
// Let op: dit is de web-variant van `lesCoach`/`lesCoachNaam` in de mobiele
// app (`src/utils/helpers.js`). Er is geen gedeeld package tussen Expo en
// React/Vite — bij wijzigingen beide plekken bijwerken.
//
// Rijen uit `get_client_training_agenda` (Fase 2, 2026-08-06) hebben géén
// `executing_coach`: die RPC doet de COALESCE al server-side en levert het
// resultaat als `coach`. Deze helper valt daar dus vanzelf goed op terug —
// verwijder die tweede tak niet.
export function lesCoach(les) {
  return les?.executing_coach || les?.coach || null;
}

export function lesCoachNaam(les) {
  return lesCoach(les)?.full_name || '';
}
